import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import SettingsDepartmentsBaseController from './base';

export default class SettingsDepartmentsListController extends SettingsDepartmentsBaseController {
  @service store;
  @service intl;

  queryParams = ['search'];
  @tracked search = '';

  get departments() {
    let departments = this.model;

    if (this.search) {
      departments = departments.filter((department) => {
        return (department.name ?? '')
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });
    }

    return departments;
  }

  @action
  async setTeams(department, e) {
    const teams = e.map((id) => this.store.peekRecord('team', id));

    let promises = [];
    // Remove department from teams that are no longer assigned
    const currentTeams = await department.teams;
    for (const team of currentTeams.slice()) {
      if (!teams.includes(team)) {
        team.department = null;
        promises.push(team.save());
      }
    }

    // Set department on new teams
    for (const team of teams) {
      team.department = department;
      promises.push(team.save());
    }

    await Promise.all(promises);
  }

  @action
  async clearTeams(department) {
    const teams = await department.teams;
    for (const team of teams.slice()) {
      team.department = null;
      await team.save();
    }
  }

  @action
  deleteDepartment(department) {
    department.destroyRecord();
  }
}
